import { createUserEmailDraft } from "@/Utile/userEmailAccounts.mjs";

export const createUserEmailFormDialogState = ({
  mode = "create",
  account = null,
  userEmail = "",
  userName = "",
} = {}) => ({
  show: true,
  mode,
  editPassword: false,
  saving: false,
  error: "",
  existingHasSecret: Boolean(account?.secret_key_version),
  data: account
    ? {
        id: account.id,
        name: account.name || "",
        description: account.description || "",
        providerKey: account.provider_key || "generic",
        transportMode: account.transport_mode || "company_default",
        isDefault: Boolean(account.is_default),
        status: account.status || "active",
        companySmtpAccountId: account.company_smtp_account_id || null,
        host: account.host || "",
        port: Number(account.port || 587),
        secure: Boolean(account.secure),
        requireTLS: Boolean(account.require_tls),
        authType: account.auth_type || "password",
        username: account.username || "",
        password: "",
        fromEmail: account.from_email || "",
        fromName: account.from_name || "",
        replyToEmail: account.reply_to_email || "",
      }
    : createUserEmailDraft({ userEmail, userName }),
});

export const createEmptyUserEmailFormDialogState = () => ({
  ...createUserEmailFormDialogState(),
  show: false,
});

export const createUserEmailSendTestDialogState = (account = null, to = "") => ({
  show: true,
  account,
  to,
  sending: false,
  error: "",
});

export const createEmptyUserEmailSendTestDialogState = () => ({
  ...createUserEmailSendTestDialogState(),
  show: false,
});

export const createUserEmailDeleteDialogState = (account = null) => ({
  show: true,
  account,
  confirmation: "",
  deleting: false,
  error: "",
});

export const createEmptyUserEmailDeleteDialogState = () => ({
  ...createUserEmailDeleteDialogState(),
  show: false,
});

export const validateUserEmailFormDialog = (formDialog, t) => {
  const data = formDialog.data;
  if (![data.name, data.fromEmail].every((value) => String(value || "").trim())) {
    formDialog.error = t("settings.profile.emailAccounts.dialog.requiredField");
    return false;
  }
  if (data.transportMode !== "own_smtp") return true;
  if (![data.host, data.port].every((value) => String(value || "").trim())) {
    formDialog.error = t("settings.profile.emailAccounts.dialog.requiredField");
    return false;
  }
  const port = Number(data.port);
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    formDialog.error = t("settings.profile.emailAccounts.dialog.invalidPort");
    return false;
  }
  if (data.authType === "password" && !String(data.username || "").trim()) {
    formDialog.error = t("settings.profile.emailAccounts.dialog.requiredField");
    return false;
  }
  const needsPassword =
    data.authType === "password" &&
    (formDialog.mode === "create" || formDialog.editPassword || !formDialog.existingHasSecret);
  if (needsPassword && !String(data.password || "").trim()) {
    formDialog.error = t("settings.profile.emailAccounts.dialog.passwordRequired");
    return false;
  }
  return true;
};
